import React from "react";

function Contact() {
  return (
    <>
      <div
        id="Contact"
        data-aos-easing="ease-in-out"
        data-aos="fade-in"
        data-aos-offset="400"
        data-aos-duration="1000"
        className="container text-center mt-5 mb-5"
      >
        <div className="row">
          <h1 className="mb-4 ">Contact me</h1>
          <div className="col-lg-4 col-md-4 col-sm-12 col-12 my-3">
            <div class="card contact-card">
              <div className="contact-icon mb-3 text-center">
                <i class="fas fa-phone-alt"></i>
              </div>
              <h4 class="card-title text-center">Contact Number</h4>
              <p class="card-text">+91 9702891744</p>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-12 my-3">
            <div class="card contact-card">
              <div className="contact-icon mb-3 text-center">
                <i class="far fa-envelope"></i>
              </div>
              <h4 class="card-title text-center">Email Address</h4>
              <p class="card-text">cbirmole@gmail.com</p>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-12 my-3">
            <div
              class="card contact-card"
              onClick={() => {
                window.open("https://chetanbirmole.netlify.app");
              }}
            >
              <div className="contact-icon mb-3 text-center">
                <i class="fas fa-globe-americas"></i>
              </div>
              <h4 class="card-title text-center">Website</h4>
              <p class="card-text">https://chetanbirmole.netlify.app</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;
